import { useEffect, useState } from 'react';
import FloatingShape from './FloatingShape';

export const LoginAnimatedBackground = () => {
  const [animationOffset, setAnimationOffset] = useState(0);

  useEffect(() => {
    let animationFrameId: number;
    let lastUpdate = (window.performance as Performance).now();

    const animate = (time: number) => {
      if (time - lastUpdate > 50) {
        setAnimationOffset(prev => (prev + 1) % 360);
        lastUpdate = time;
      }
      animationFrameId = window.requestAnimationFrame(animate);
    };

    animationFrameId = window.requestAnimationFrame(animate);

    return () => window.cancelAnimationFrame(animationFrameId);
  }, []);

  return (
    <div className="w-1/2 bg-[#242424] relative overflow-hidden hidden md:block">
      <div className="absolute inset-0 flex items-center justify-center">
        {/* Floating Shapes */}
        {[...Array(6)].map((_, i) => (
          <FloatingShape
            key={`main-${i}`}
            i={i}
            animationOffset={animationOffset}
            svg={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="39"
                viewBox="0 0 36 39"
                fill="none"
              >
                <g opacity="0.1" filter="url(#filter0_f_main)">
                  <path
                    d="M10 15.7076V22.8718C10 23.5663 10.3561 24.2067 10.9367 24.554L16.9188 28.1371C17.4975 28.4843 18.2116 28.4843 18.7903 28.1371L24.7724 24.554C25.3511 24.2067 25.7091 23.5663 25.7091 22.8718V15.7076C25.7091 15.013 25.353 14.3727 24.7724 14.0254L18.7903 10.4443C18.2116 10.097 17.4975 10.097 16.9188 10.4443L10.9367 14.0254C10.358 14.3727 10 15.013 10 15.7076Z"
                    fill="#CCE561"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_f_main"
                    x="0"
                    y="0.183838"
                    width="35.7091"
                    height="38.2136"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                  >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="5" result="effect1_foregroundBlur_main" />
                  </filter>
                </defs>
              </svg>
            }
          />
        ))}

        {[...Array(5)].map((_, i) => (
          <FloatingShape
            key={`small-${i}`}
            i={i}
            animationOffset={animationOffset}
            svg={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="19"
                viewBox="0 0 17 19"
                fill="none"
              >
                <path
                  opacity="0.1"
                  d="M0.963867 6.25785V13.4221C0.963867 14.1166 1.31997 14.757 1.90057 15.1042L7.88268 18.6874C8.46134 19.0346 9.17548 19.0346 9.75415 18.6874L15.7363 15.1042C16.3149 14.757 16.673 14.1166 16.673 13.4221V6.25785C16.673 5.56331 16.3169 4.92297 15.7363 4.5757L9.75415 0.994584C9.17548 0.647313 8.46134 0.647313 7.88268 0.994584L1.90057 4.5757C1.3219 4.92297 0.963867 5.56331 0.963867 6.25785Z"
                  fill="#CCE561"
                />
              </svg>
            }
          />
        ))}

        {[...Array(5)].map((_, i) => (
          <FloatingShape
            key={`large-${i}`}
            i={i}
            animationOffset={animationOffset}
            svg={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="45"
                height="46"
                viewBox="0 0 45 46"
                fill="none"
              >
                <g opacity="0.1" filter="url(#filter0_f_large)">
                  <path
                    d="M10 17.628V27.5215C10 28.4806 10.5539 29.3649 11.4571 29.8444L20.7626 34.7926C21.6627 35.2721 22.7736 35.2721 23.6738 34.7926L32.9793 29.8444C33.8794 29.3649 34.4364 28.4806 34.4364 27.5215V17.628C34.4364 16.6689 33.8824 15.7846 32.9793 15.305L23.6738 10.3597C22.7736 9.88011 21.6627 9.88011 20.7626 10.3597L11.4571 15.305C10.5569 15.7846 10 16.6689 10 17.628Z"
                    fill="#CCE561"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_f_large"
                    x="0"
                    y="0"
                    width="44.4363"
                    height="45.1523"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                  >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="5" result="effect1_foregroundBlur_large" />
                  </filter>
                </defs>
              </svg>
            }
          />
        ))}

        {[...Array(5)].map((_, i) => (
          <FloatingShape
            key={`mid-${i}`}
            i={i}
            animationOffset={animationOffset}
            svg={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="33"
                viewBox="0 0 27 33"
                fill="none"
              >
                <path
                  opacity="0.1"
                  d="M0 10.008V22.9883C0 24.2467 0.612049 25.4069 1.60995 26.0361L11.8917 32.5281C12.8863 33.1573 14.1137 33.1573 15.1083 32.5281L25.39 26.0361C26.3846 25.4069 27 24.2467 27 22.9883V10.008C27 8.74963 26.388 7.58944 25.39 6.96024L15.1083 0.471896C14.1137 -0.157299 12.8863 -0.157299 11.8917 0.471896L1.60995 6.96024C0.615375 7.58944 0 8.74963 0 10.008Z"
                  fill="#CCE561"
                />
              </svg>
            }
          />
        ))}

        {/* Central hexagonal shapes */}
        <div className="relative flex items-center">
          {[...Array(2)].map((_, i) => {
            const angle = i * 180;
            const amplitude = 40;
            const x = Math.cos(((animationOffset + i * 20) * Math.PI) / 180 + angle) * amplitude;
            const y = Math.sin(((animationOffset + i * 20) * Math.PI) / 180 + angle) * amplitude;

            return (
              <svg
                key={i}
                xmlns="http://www.w3.org/2000/svg"
                width="1.85456rem"
                height="2.00569rem"
                viewBox="0 0 30 33"
                fill="none"
                className="absolute"
                style={{
                  top: `50%`,
                  left: `50%`,
                  transform: `translate(calc(-50% + ${x}px), calc(-50% + ${y}px))`,
                  transition: 'transform 1s ease-in-out',
                  zIndex: 10,
                }}
              >
                <path
                  d="M0.0185547 9.99741V22.6201C0.0185547 23.8438 0.69119 24.972 1.78788 25.5839L13.0874 31.897C14.1805 32.5089 15.5294 32.5089 16.6224 31.897L27.922 25.5839C29.015 24.972 29.6913 23.8438 29.6913 22.6201V9.99741C29.6913 8.77369 29.0186 7.64547 27.922 7.03361L16.6224 0.724031C15.5294 0.112172 14.1805 0.112172 13.0874 0.724031L1.78788 7.03361C0.694846 7.64547 0.0185547 8.77369 0.0185547 9.99741Z"
                  fill="#CCE561"
                  opacity={0.8}
                />
              </svg>
            );
          })}

          {[...Array(3)].map((_, i) => {
            const angle = i * 120;
            const radius = 80;
            const rad = angle * (Math.PI / 180);
            const x = Math.cos(rad) * radius;
            const y = Math.sin(rad) * radius;

            return (
              <svg
                key={i}
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="33"
                viewBox="0 0 30 33"
                fill="none"
                className="absolute"
                style={{
                  top: `calc(50% + ${y}px)`,
                  left: `calc(50% + ${x}px)`,
                  transform: `translate(-50%, -50%) rotate(${angle}deg)`,
                  transition: 'transform 1s ease-in-out',
                }}
              >
                <defs>
                  <linearGradient id={`grad-${i}`} x1="0" y1="0" x2="0" y2="1">
                    <stop offset="50%" stopColor="#CCE561" stopOpacity="0.8" />
                    <stop offset="100%" stopColor="#CCE561" stopOpacity="0.2" />
                  </linearGradient>
                </defs>
                <path
                  d="M0.0185547 9.99741V22.6201C0.0185547 23.8438 0.69119 24.972 1.78788 25.5839L13.0874 31.897C14.1805 32.5089 15.5294 32.5089 16.6224 31.897L27.922 25.5839C29.015 24.972 29.6913 23.8438 29.6913 22.6201V9.99741C29.6913 8.77369 29.0186 7.64547 27.922 7.03361L16.6224 0.724031C15.5294 0.112172 14.1805 0.112172 13.0874 0.724031L1.78788 7.03361C0.694846 7.64547 0.0185547 8.77369 0.0185547 9.99741Z"
                  fill={`url(#grad-${i})`}
                />
              </svg>
            );
          })}

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="149"
            height="165"
            viewBox="0 0 149 165"
            fill="none"
            className="absolute"
            style={{
              top: '50%',
              left: '50%',
              transform: `translate(-50%, -50%) rotate(${animationOffset * 1.5}deg)`,
              transition: 'transform 0.1s ease-out',
              position: 'absolute',
            }}
          >
            <path
              d="M2.49219 51.3616V114.213C2.49219 120.307 5.76503 125.924 11.1012 128.971L66.0814 160.406C71.3998 163.452 77.9633 163.452 83.2817 160.406L138.262 128.971C143.58 125.924 146.871 120.307 146.871 114.213V51.3616C146.871 45.2683 143.598 39.6506 138.262 36.604L83.2817 5.18682C77.9633 2.1402 71.3998 2.1402 66.0814 5.18682L11.1012 36.604C5.78282 39.6506 2.49219 45.2683 2.49219 51.3616Z"
              stroke="#334238"
              strokeWidth="4"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="293"
            height="291"
            viewBox="0 0 293 291"
            fill="none"
            className="absolute"
            style={{
              top: '50%',
              left: '50%',
              transform: `translate(-50%, -50%) rotate(${animationOffset * 1.2}deg)`,
              transition: 'transform 0.1s ease-out',
              position: 'absolute',
            }}
          >
            <path
              d="M34.0632 55.6452L3.88687 167.567C0.961397 178.417 4.05998 189.964 12.0469 197.906L94.317 279.809C102.272 287.742 113.895 290.837 124.776 287.92L237.231 257.87C248.112 254.952 256.636 246.501 259.562 235.65L289.738 123.729C292.664 112.878 289.565 101.331 281.578 93.3897L199.3 11.5181C191.344 3.58496 179.721 0.489887 168.84 3.40712L56.394 33.4257C45.5131 36.343 36.9887 44.7949 34.0632 55.6452Z"
              stroke="#334238"
              strokeWidth="4"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="398"
            height="397"
            viewBox="0 0 398 397"
            fill="none"
            className="absolute"
            style={{
              top: '50%',
              left: '50%',
              transform: `translate(-50%, -50%) rotate(${animationOffset * 1.0}deg)`,
              transition: 'transform 0.1s ease-out',
              position: 'absolute',
            }}
          >
            <path
              d="M3.737 168.606L44.9624 321.508C48.959 336.331 60.555 347.891 75.4521 351.867L228.971 392.95C243.825 396.938 259.69 392.713 270.548 381.878L382.83 270.016C393.687 259.181 397.957 243.397 393.96 228.574L352.735 75.672C348.738 60.8488 337.142 49.289 322.245 45.3122L168.738 4.2727C153.884 0.284449 138.018 4.50925 127.161 15.3442L14.8673 127.163C4.00986 137.998 -0.259632 153.783 3.737 168.606Z"
              stroke="#334238"
              strokeWidth="4"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="474"
            height="527"
            viewBox="0 0 474 527"
            fill="none"
            className="absolute"
            style={{
              top: '50%',
              left: '50%',
              transform: `translate(-50%, -50%) rotate(${animationOffset * 0.8}deg)`,
              transition: 'transform 0.1s ease-out',
              position: 'absolute',
            }}
          >
            <path
              d="M2.09033 160.895L2.09033 366.27C2.09033 386.18 12.7338 404.536 30.0873 414.492L208.886 517.208C226.182 527.163 247.526 527.163 264.822 517.208L443.621 414.492C460.916 404.536 471.618 386.18 471.618 366.27V160.895C471.618 140.985 460.974 122.628 443.621 112.673L264.822 10.0147C247.526 0.0595609 226.182 0.0595609 208.886 10.0147L30.0873 112.673C12.7916 122.628 2.09033 140.985 2.09033 160.895Z"
              stroke="#334238"
              strokeWidth="4"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="648"
            height="645"
            viewBox="0 0 648 645"
            fill="none"
            className="absolute"
            style={{
              top: '50%',
              left: '50%',
              transform: `translate(-50%, -50%) rotate(${animationOffset * 0.6}deg)`,
              transition: 'transform 0.1s ease-out',
              position: 'absolute',
            }}
          >
            <path
              d="M71.7638 121.586L4.4172 371.37C-2.11178 395.585 4.82485 421.361 22.6844 439.094L206.65 621.978C224.439 639.692 250.422 646.611 274.74 640.109L526.071 573.14C550.389 566.638 569.435 547.781 575.964 523.566L643.311 273.783C649.84 249.567 642.903 223.791 625.044 206.059L441.059 23.2448C423.27 5.53072 397.287 -1.38815 372.969 5.11323L121.657 72.0125C97.3388 78.5139 78.2928 97.3709 71.7638 121.586Z"
              stroke="#334238"
              strokeWidth="4"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};
